<template lang="pug">
div.d-inline(@click.stop)
	v-btn.ml-2(icon small @click="showModal = true")
		v-icon(x-small color="primary") info
	ws-dialog(v-model="showModal" :title="coverageInfo.name" v-if="coverageInfo.name")
		v-img(v-if="coverageInfo.photo" :src="`${coverageInfo.photoUrl}?width=640`" aspect-ratio="2.75")
		v-card-text
			ws-content(v-model="coverageInfo.content")
	v-chip.ml-2(v-if="percentageLabel" label color="success" text-color="white" small) Gekozen door {{coverageInfo.percentage}}%
</template>

<script>
import gql from 'graphql-tag';

const query = gql`
	query coverageInfoBySlug($slug: String!) {
		coverageinfo: coverageInfoBySlug(slug: $slug) {
			name
			photo
			photoUrl
			content {
				markdown
			}
			percentage
		}
	}
`;

export default {
	name: 'Hovertag',
	props: {
		field: {
			type: String,
			required: true
		},
		percentageLabel: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			showModal: false,
			coverageInfo: {}
		};
	},
	created() {
		this.loadInfo();
	},
	methods: {
		loadInfo() {
			this.$graphClient
				.query({
					query,
					variables: {
						slug: this.field
					},
					fetchPolicy: 'no-cache'
				})
				.then(({ data }) => {
					this.coverageInfo = data.coverageinfo;
				});
		}
	}
};
</script>
